<template>
    <div class="l-main ">
        <div class="l-main-content container-xl bg-white-shadow" style="max-width: 1480px;">
            <div class="row border-bottom border-top">
    
                <div class="col-4">
                    <h3>Summary</h3>
                </div>
                <div class="col-8 text-right">
                    <span class="s"> 
                                                    <date-range-picker :opens="opens" ref="picker" v-model="dateRange" @update="searchRecords" :auto-apply="applyDate"> 
                                                        <template v-slot:input="picker"  style="min-width: 350px;">
</template>
                        </date-range-picker>
                    </span>
                </div>
                <div class="row">
                    <loader v-show='loading' />
            </div>
            </div>
            <div class="row rsum  ">
       
                    <div class="sum teal col">
                        <div class="h">Total Deposit</div>
                        <div class="t">KES {{deposit  | formatAmount}}</div>
                        <div class="s"> Lotto Deposit KES {{lottoDeposit | formatAmount}}</div>
                    </div>
                    <div class="sum blue col">
                        <div class="h">Total Withdraw</div>
                        <div class="t">KES {{ withdraws   | formatAmount}}</div>
                        <div class="s">Lotto Withdraws KES {{ lottoWithdraws | formatAmount}}</div>
                    </div>
        
                </div>
                <div class="row rsum">
          
                    <div class="sum red col">
                        <div class="h">Stake</div>
                        <div class="t">KES {{stake | formatAmount}}</div>
                    </div>
                    <div class="sum yellow col">
                        <div class="h">Wins</div>
                        <div class="t">KES {{wins | formatAmount}}</div>
                    </div>
                    <div class="sum blue col">
                        <div class="h">P&L</div>
                        <div class="t">KES {{profit | formatAmount}}</div>
                        <div class="s hidden"><i class="fa fa-caret-down"></i> {{profit/(lastprofit+profit) * 100 | formatPercent}}%</div>
                    </div>
                    <div class="sum purple col">
                        <div class="h">Void</div>
                        <div class="t">KES {{voidAmount | formatAmount}}</div>
                        <div class="s hidden"><i class="fa fa-caret-down"></i> {{profit/(lastprofit+profit) * 100 | formatPercent}}%</div>
                    </div>
             
    
                
            </div>
            <div class="row border-bottom" style="margin-bottom: 30px;">
                <div class="divider"></div>
                <div class="col">
                    <div>Deposit per Day</div>
                    <div class="p-top"><canvas id="purchase-chart" height="300"></canvas></div>
                </div>
            </div>

            <b-tabs content-class="mt-3">
                <b-tab title="SpinWheel" active> 
           
                        <div class="col overflow">
                            <h5 style="margin-bottom: 10px;">Spinwheel Summary</h5>
                            <table class="table simple" id="purchaseTable" style="padding: 10px;">
                                <thead class="med">
                                    <tr>
                                        <th>Game</th>
                                        <th >Deposit</th>
                                        <th >Withdraw</th>
                                        <th >RTP</th>
                                        <th >Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(entry, index) in spinWheelSummary" :key="index+1">
                                        <td class="text-grey text-left">{{entry.spin_game}}</td>
                                        <td class="long text-left">{{entry.total_amt_wagered | formatAmount }}</td>
                                        <td class="long text-left">{{entry.total_amt_paid | formatAmount }}</td>
                                        <td class="long text-left">{{entry.current_RTP }}</td>
                                        <td class="long text-left">{{entry.dateApp }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
     
                </b-tab>
                <b-tab title="Aviator Summary">
                    <div class="col overflow">
                    <h5 style="margin-bottom: 10px;">Aviator Summary</h5>
                    <table class="table simple" id="purchaseTable">
                        <thead class="med">
                            <tr>
                                <th>Game</th>
                                <th >Deposit</th>
                                <th >Withdraw</th>
                                <th >RTP</th>
                                <th >Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(entry, index) in aviatorSummary" :key="index+1">
                                <td class="text-grey text-left">{{entry.avaitor_game}}</td>
                                <td class="long text-left">{{entry.total_amt_wagered | formatAmount}}</td>
                                <td class="long text-left">{{entry.total_amt_paid | formatAmount }}</td>
                                <td class="long text-left">{{entry.current_RTP }}</td>
                                <td class="long text-left">{{entry.dateApp }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </b-tab>
                <b-tab title="Pickbox Summary">
                    <div class="col overflow">
                    <h5 style="margin-bottom: 10px;">Pickbox Summary</h5>
                    <table class="table simple" id="purchaseTable">
                        <thead class="med">
                            <tr>
                                <th>Game</th>
                                <th >Deposit</th>
                                <th >Withdraw</th>
                                <th >RTP</th>
                                <th >Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(entry, index) in pickboxSummary" :key="index+1">
                                <td class="text-grey text-left">{{entry.pickbox_game}}</td>
                                <td class="long text-left">{{entry.total_amt_wagered | formatAmount }}</td>
                                <td class="long text-left">{{entry.total_amt_paid | formatAmount }}</td>
                                <td class="long text-left">{{entry.current_RTP }}</td>
                                <td class="long text-left">{{entry.dateApp }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </b-tab>
                <b-tab title="Deposit Summary">
                    <div class="col overflow">
                        <h5 style="margin-bottom: 10px;">Deposit Summary</h5>
                        <table class="table simple" id="purchaseTable">
                            <thead class="med">
                                <tr>
                                    <th>Campaign Name</th>
                                    <th >Deposit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in depositSummary" :key="index+1">
                                    <td class="text-grey text-left">{{entry.source}}</td>
                                    <td class="long text-left">{{entry.deposit | formatAmount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-tab>
                <b-tab title="Signup Summary">
                    <div class="col overflow">
                        <h5 style="margin-bottom: 10px;">Signup Summary</h5>
                        <table class="table simple" id="purchaseTable">
                            <thead class="med">
                                <tr>
                                    <th>Campaign Name</th>
                                    <th >Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in signupSummary" :key="index+1">
                                    <td class="text-grey text-left">{{entry.channel}}</td>
                                    <td class="long text-left">{{entry.total | formatNumber }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-tab>
                <b-tab title="Referral Summary">
                    <div class="col overflow">
                        <h5 style="margin-bottom: 10px;">Referral Summary</h5>
                        <table class="table simple" id="purchaseTable">
                            <thead class="med">
                                <tr>
                                    <th>Type</th>
                                    <th >Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in referralSummary" :key="index+1">
                                    <td class="text-grey text-left">{{entry.type}}</td>
                                    <td class="long text-left">{{entry.value | formatNumber }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-tab>
                <b-tab title="Bonus Summary">
                    <div class="col overflow">
                        <h5 style="margin-bottom: 10px;">Bonus Summary</h5>
                        <table class="table simple" id="purchaseTable">
                            <thead class="med">
                                <tr>
                                    <th>Type</th>
                                    <th >Total Bonus</th>
                                    <th >Bonus Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(entry, index) in bonusSummaries" :key="index+1">
                                    <td class="text-grey text-left">{{entry.name}}</td>
                                    <td class="long text-left">{{entry.totalBonus | formatNumber }}</td>
                                    <td class="long text-left">{{ parseInt(entry.totalBonus) * parseInt(entry.bonus_amount) | formatAmount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-tab>
            </b-tabs>
            <div class="row  border-top">
            
                    
                    <div class="col">
                        <h3>Customers</h3>
                        <h4>Returning</h4>
                        <h3 style="color: #0076FF"><strong>{{returnCustomer}}</strong></h3>
                        <small>{{percentReturnCustomer}}%</small>
    
                        <div class="divider"></div>
    
                        <h4>New</h4>
                        <h3 style="color: #AE00D8"><strong>{{newCustomer}}</strong></h3>
                        <small>{{percentNewCustomer}}%</small>
                    </div>
                    <div class="col">
                        <canvas id="customers-chart" width="200" height="130"></canvas>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import Chart from "chart.js";
import store from "../store";
import $ from 'jquery';
import numeral from "numeral";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import loader from "@/components/loader";
import { formatNumber } from "accounting";
export default {
    components: {
        DatePicker,
        DateRangePicker,
        loader
    },
    data() {
        return {

            dateRange: {
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD')
            },
            loading: true,
            opens: "center",
            applyDate: true,
            time3: "",
            selectedTab: 'summary',
            deposit: 0,
            lottoDeposit: 0,
            withdraws: 0,
            lottoWithdraws: 0,
            lastwithdraws: 0,
            profit: 0,
            voidAmount: 0,
            lastdeposit: 0,
            lastnet: 0,
            lastprofit: 0,
            customers: 0,
            source: [],
            depositSummary: [],
            aviatorSummary: [],
            pickboxSummary: [],
            signupSummary: [],
            referralSummary: [],
            spinWheelSummary: [],
            bonusSummaries: [],
            partners: [{
                    name: 'Evo',
                    totalAmount: 120
                },
                {
                    name: 'Betixon',
                    totalAmount: 80
                }
            ],
            channels: [],
            channelAttribute: [{
                    utm_campaign: 'Safaricom',
                    total: 2,
                    amount: 80
                },
                {
                    utm_campaign: 'Google',
                    total: 3,
                    amount: 120
                },
            ],
            days: 0,
            newCustomer: 0,
            percentNewCustomer: 40,
            returnCustomer: 0,
            percentReturnCustomer: 60,
            totalAmountDeposit: 200,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            time3: "",
            stake: 0,
            wins: 0
        }
    },
    mounted() {

        let vm = this;
        vm.loadChart()
        vm.loadCustomerChart()
        vm.getSummary()
        vm.getAviatorSummary()
        vm.getChannelSummary()
        vm.getSpinWheelSummary()
        vm.getPickboxSummary()
        vm.getDepositSummary()
        vm.getSignUpSummary()
        vm.getReferralSummary()
        vm.getBonusSummary()

    },
    methods: {

        getBonusSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/summary/bonus',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.bonusSummaries = response.data.data
                    } else {
                        vm.bonusSummaries = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.status == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },

        getChannelSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/channels/summary',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.source = response.data.data.data
                    } else {
                        vm.source = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.status == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },
        getDepositSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/utm/deposit/summary',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.depositSummary = response.data.data
                    } else {
                        vm.depositSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.status == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },
        getSignUpSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/utm/signup/summary',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.signupSummary = response.data.data
                    } else {
                        vm.signupSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.status == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },
        getReferralSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/referral/summary',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.referralSummary = response.data.data
                    } else {
                        vm.referralSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.status == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },
        getAviatorSummary() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'v1/aviator/ussd/view/summary',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    days: vm.days,
                    start: vm.startDate,
                    end: vm.endDate
                }),
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.aviatorSummary = response.data.data
                    } else {
                        vm.aviatorSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));

                }
            });
        },
        getSpinWheelSummary() {
            let vm = this
            $.post({
                url: store.state.rootUrl + 'v1/spinwheel/ussd/view/summary',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    days: vm.days,
                    start: vm.startDate,
                    end: vm.endDate
                }),
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.spinWheelSummary = response.data.data
                    } else {
                        vm.spinWheelSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));

                }
            });
        },
        getPickboxSummary() {
            let vm = this

            $.post({
                url: store.state.rootUrl + 'v1/pickbox/ussd/view/summary',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    start: vm.startDate,
                    end: vm.endDate
                }),
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        vm.pickboxSummary = response.data.data
                    } else {
                        vm.pickboxSummary = []
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));

                }
            });
        },
        getSummary() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'v1/dashboard/lotto/summary/stakes',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    vm.loading = false
                    if (response.data.code == 200) {
                        console.log("Record" + response.data.data.pickboxBets.deposit)
                        var list_summary = response.data.data;
                        var stake = 0
                        var wins = 0
                        var refund = 0
                        var voidAmt = 0;
                        
                        vm.withdraws = response.data.data.mpesaWithdraws
                        vm.lottoDeposit = Number(response.data.data.pickboxBets.deposit) + Number(response.data.data.spinWheelBets.deposit) + Number(response.data.data.aviatorBets.deposit);
                        vm.lottoWithdraws = Number(response.data.data.pickboxBets.Withdraw) + Number(response.data.data.spinWheelBets.Withdraw) + Number(response.data.data.aviatorBets.Withdraw);

                        var summaryData = response.data.data.data;
                        summaryData.forEach(element => {
                            if(element.identifier_name == "STAKE"){
                                stake = parseFloat(element.amount)
                            }
                            if(element.identifier_name == "WINNINGS"){
                                wins = parseFloat(element.amount)
                            }
                            if(element.identifier_name == "REFUNDS"){
                                refund = parseFloat(element.amount)
                            }
                            if(element.identifier_name == "VOIDING"){
                                voidAmt = parseFloat(element.amount)
                            }
                            
                        });
                        vm.stake = stake;
                        vm.wins = wins;
                        vm.profit = stake - (wins+refund+voidAmt)
                        vm.voidAmount = voidAmt;



                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.data.code == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
        },
        loadChart() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/mpesa_deposits/graph',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    days: vm.days,
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    if (response.data.code == 200) {
                        var list_summary = response.data.data.data;
                        var date = []
                        var deposit = []
                        var totalDesposit = 0
                        list_summary.forEach(function(data) {
                            date.unshift(moment(data['date']).format("D MMM"))
                            totalDesposit = totalDesposit + Number(data['totalDeposit'])
                            deposit.push(data['totalDeposit'])

                        });
                        vm.deposit = totalDesposit
                        var ctx = $('#purchase-chart');
                        var customersChart = new Chart(ctx, {
                            type: 'bar',
                            data: {
                                datasets: [{
                                    data: deposit,
                                    backgroundColor: '#00B979'
                                }],
                                labels: date,
                            },
                            options: {
                                maintainAspectRatio: false,
                                responsive: true,
                                legend: {
                                    display: false
                                },
                                scales: {
                                    xAxes: [{
                                        gridLines: {
                                            display: false
                                        }
                                    }],
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true
                                        }
                                    }]
                                }
                            }
                        });
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.data.code == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });

        },
        loadCustomerChart() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/view/profile/summary',
                type: "GET",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "X-Token-Key": this.$cookies.get("accessToken")
                },
                data: {
                    days: vm.days,
                    start: vm.startDate,
                    end: vm.endDate
                },
                success: function(response, status, jQxhr) {
                    console.log("profile- " + JSON.stringify(response.data.data));
                    if (response.data.code == 200) {
                        var list_summary = response.data.data.data;
                        vm.newCustomer = list_summary[0].totalNew;
                        vm.returnCustomer = list_summary[0].totalreturn;
                        var total = Number(list_summary[0].totalNew) + Number(list_summary[0].totalreturn);
                        vm.percentNewCustomer = (((Number(list_summary[0].totalNew)) / total) * 100).toFixed(2);
                        vm.percentReturnCustomer = ((Number(list_summary[0].totalreturn) / total) * 100).toFixed(2);

                        var ctx = $('#customers-chart');
                        var customersChart = new Chart(ctx, {
                            type: 'pie',
                            data: {
                                datasets: [{
                                    data: [vm.percentNewCustomer, vm.percentReturnCustomer],
                                    backgroundColor: [
                                        '#AE00D8',
                                        '#0076FF',
                                    ]
                                }],
                                labels: ['New', 'Returning'],
                            },
                            options: {
                                maintainAspectRatio: false,
                                responsive: true,
                                legend: {
                                    display: false
                                }
                            }
                        });
                        console.log(JSON.stringify(list_summary))

                        var ctx = $('#customers-chart');
                        var customersChart = new Chart(ctx, {
                            type: 'pie',
                            data: {
                                datasets: [{
                                    data: ['40', '60'],
                                    backgroundColor: [
                                        '#AE00D8',
                                        '#0076FF',
                                    ]
                                }],
                                labels: ['New', 'Returning'],
                            },
                            options: {
                                maintainAspectRatio: false,
                                responsive: true,
                                legend: {
                                    display: false
                                }
                            }
                        });
                    }

                },
                error: function(jQxhr, status, error) {
                    console.log(JSON.stringify(jQxhr));
                    if (jQxhr.data.code == 401) {
                        vm.$cookies.remove("accessToken");
                        vm.$cookies.remove("profileInfo");
                        vm.$cookies.remove("role_id");
                        vm.$router.push({
                            name: 'login'
                        });
                    }

                }
            });
            var ctx = $('#customers-chart');
            var customersChart = new Chart(ctx, {
                type: 'pie',
                data: {
                    datasets: [{
                        data: ['40', '60'],
                        backgroundColor: [
                            '#00C654',
                            '#AE00D8',
                        ]
                    }],
                    labels: ['New', 'Returning'],
                },
                options: {
                    maintainAspectRatio: false,
                    responsive: true,
                    legend: {
                        display: false
                    }
                }
            });
        },
        searchRecords() {
            let vm = this;
            vm.loader

            console.log("Date " + JSON.stringify(vm.dateRange))


            vm.days = 0;
            var timString = vm.time3 + "";

            vm.startDate = vm.format_date(vm.dateRange.startDate) + " 00:00:00";
            vm.endDate = vm.format_date(vm.dateRange.endDate) + " 23:59:59";

            vm.aviatorSummary = []
            vm.pickboxSummary = []
            vm.source = []
            vm.spinWheelSummary = []
            vm.deposit = 0
            vm.withdraws = 0
            vm.profit = 0
            vm.newCustomer = 0
            vm.stake = 0
            vm.wins = 0
            vm.returnCustomer = 0
            vm.lottoDeposit = 0
            vm.lottoWithdraws = 0
            vm.referralSummary = []
            vm.signupSummary = []
            vm.depositSummary = []
            vm.bonusSummaries = []
            vm.loadChart()
            vm.loadCustomerChart()
            vm.getSummary()
            vm.getAviatorSummary()
            vm.getPickboxSummary()
            vm.getChannelSummary()
            vm.getSpinWheelSummary()
            vm.getDepositSummary()
            vm.getSignUpSummary()
            vm.getReferralSummary()
            vm.getBonusSummary()

        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    filters: {
        formatAmount(value) {
            return numeral(value).format("0,0.00");
        },
        formatPercent(value) {
            return numeral(value).format("0,0.00");
        },
        formatNumber(value) {
            return numeral(value).format("0,0");
        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            } else {
                return ""
            }
        },
        
    }
}
</script>
